import { css } from '@emotion/core';
import styled from '@emotion/styled';

const DeleteAccountParagraph = styled.p`
  margin: 24px 0;
  color: #5f6368;
  font-size: 1.6rem;
`;

const DeleteContainerCss = css`
  width: 100%;
  max-width: 690px;
  @media (max-width: 600px) {
    padding: 0 24px 24px;
  }
`;

const OverridePanelCss = css`
  a:hover {
    text-decoration: none;
    cursor: pointer;
  }
  .panel-default {
    border: 0;
  }
  .panel-collapse {
    cursor: default;
  }
  .panel-body {
    padding: 0;
  }
  .panel,
  .panel-heading {
    padding: 0;
    border: none;
    color: #292f36;
    background: none;
    box-shadow: none;
    &:hover {
      text-decoration: none;
    }
    h4 {
      display: inline;
      cursor: pointer;
      a {
        color: #292f36;
        &:hover,
        &:active,
        &:focus,
        &:active:focus {
          color: #292f36;
        }
      }
    }
  }
`;
export { DeleteAccountParagraph, OverridePanelCss, DeleteContainerCss };
